import * as React from "react";
import { Label as LabelPrimitive } from "radix-ui";

import { cn } from "@jbnl/shared-ui";

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        // shadcn's peer-disabled:opacity-50 becomes 45, the disabled step the rest of this
        // palette uses. See docs/adr/0025-jbnl-huisstijl-in-the-two-spas.md.
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-45 peer-disabled:cursor-not-allowed peer-disabled:opacity-45",
        className,
      )}
      {...props}
    />
  );
}

export { Label };
